import { render, staticRenderFns } from "./CProjectCreateButton.vue?vue&type=template&id=70270699&"
import script from "./CProjectCreateButton.vue?vue&type=script&lang=ts&"
export * from "./CProjectCreateButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports